// extracted by mini-css-extract-plugin
export default {"container":"PKNvT","content":"F_yfF","link":"SukvD","productCode":"Jk9Oz","badges":"XJ4Fw"};